import * as types from './constants';

export const initialState = {
  dataTable: [],
  loading: false,
  errors_api: {}
};

const actions = {
  [types.GET_LOOKBOOK_USERS_REQUEST]: state => {
    const data = {
      ...state,
      loading: true
    };

    return { ...data };
  },

  [types.GET_LOOKBOOK_USERS_DONE]: (state, { payload }) => {
    const data = {
      ...state,
      dataTable: payload,
      loading: false
    };

    return { ...data };
  },

  [types.GET_LOOKBOOK_USERS_FAILED]: (state, { payload }) => {
    const data = {
      ...state,
      loading: false,
      errors_api: payload
    };

    return { ...data };
  },

  [types.GET_LOOKBOOK_USERS_RESET]: () => {
    return { ...initialState };
  }
};

export default (state = initialState, action) => {
  if (actions[action.type]) return actions[action.type](state, action);
  return state;
};
